import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useReducer } from 'react';
import { ProviderSetupModalContent } from './ProviderSetupModalContent';
export const ProviderSetupPlain = observer(_ref => {
  let utilityProviderId = _ref.utilityProviderId,
    externalIsOpen = _ref.externalIsOpen,
    handleConfigChange = _ref.handleConfigChange,
    isNew = _ref.isNew,
    propertyId = _ref.propertyId,
    isDetailsPage = _ref.isDetailsPage,
    isNewUtility = _ref.isNewUtility;
  const store = useStore();
  const _useReducer = useReducer(x => x + 1, 0),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    forceUpdate = _useReducer2[1];
  const getVendorsByUtilityProviderIdAsync = async () => {
    await store.vendors.getVendorsByUtilityProviderIdAsync.run({
      utilityProviderId: utilityProviderId
    }).then(() => {
      forceUpdate();
    });
  };
  useEffect(() => {
    if (externalIsOpen && store.company.companyFeatureStore.isAppfolio && store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled) getVendorsByUtilityProviderIdAsync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [externalIsOpen]);
  return /*#__PURE__*/React.createElement(ProviderSetupModalContent, {
    key: isNew ? 'PROVIDER_SETUP_MODAL_CONTENT_KEY' : "PROVIDER_SETUP_MODAL_CONTENT_KEY_".concat(utilityProviderId),
    id: isNew ? 'PROVIDER_SETUP_MODAL_CONTENT_ID' : "PROVIDER_SETUP_MODAL_CONTENT__ID_".concat(utilityProviderId),
    handleConfigChange: handleConfigChange,
    isNew: isNew,
    isEdit: false,
    isDetailsPage: isDetailsPage,
    isNewUtility: isNewUtility,
    hideNotEnabled: false,
    propertyId: propertyId,
    hideSaved: true
  });
});